<template>
    <transition name="pm-fade-in-slide-up-transition">
        <component ref="dialog" v-if="dialog!==''" v-bind:is="dialog" @close="close" :dialogData="dialogData"></component>
    </transition>
</template>
<script>

import extraFeaturesOffer from "./extra-features-offer.vue"
import extraTrialOffer from "./extra-trial-offer.vue"
import userProfession from "./user-profession.vue";
import userEmail from "./user-email.vue";
import review from "./review.vue";
import premium from "./premium.vue";
import welcomeMessage from "./welcome-message.vue";
import pdfViewerGdocs from "./pdf-viewer-gdocs.vue";
import toothIdSelector from "./tooth-id-selector.vue";
import premiumOffer from "./premium-offer.vue";
import discount from "./discount.vue";
import discountRefuse from "./discount-refuse.vue";
import winWheel from "./winwheel.vue";
import videoDialog from "./video.vue";
import storeErrorDialog from "./store-error-dialog.vue";
import storeCancelDialog from "./store-cancel-dialog.vue";
// import premiumRefuse from "./premium-refuse.vue";
import trialDaysLeft from "./trial-days-left.vue";
import storeSupport from "./store-support.vue";
import priceWorthIt from "./price-worth-it.vue";
import pricelistTutorial from "./pricelist-tutorial.vue";
import videoPlayer from "./video-player.vue";
export default {
    components: {
        extraFeaturesOffer,
        extraTrialOffer,
        userProfession,
        userEmail,
        review,
        premium,
        welcomeMessage,
        pdfViewerGdocs,
        toothIdSelector,
        premiumOffer,
        discount,
        winWheel,
        discountRefuse,
        videoDialog,
        storeErrorDialog,
        storeCancelDialog,
        // premiumRefuse,
        trialDaysLeft,
        storeSupport,
        priceWorthIt,
        pricelistTutorial,
        videoPlayer,
    },
    data: () => ({
        dialog: "",
        dialogData: {},
        components: {
            extraFeaturesOffer,
            extraTrialOffer,
            userProfession,
            userEmail,
            review,
            premium,
            welcomeMessage,
            pdfViewerGdocs,
            toothIdSelector,
            premiumOffer,
            discount,
            winWheel,
            discountRefuse,
            videoDialog,
            storeErrorDialog,
            storeCancelDialog,
            // premiumRefuse,
            trialDaysLeft,
            storeSupport,
            priceWorthIt,
            pricelistTutorial,
            videoPlayer,
        },
    }),
    created() {
        this.registerBusEvent('openAppDialog', (id, data = {}) => {
            this.dialogData = data;
            this.dialog = this.components[id];
            this.$nextTick(()=>{
                this.$refs['dialog'].show();
            });
            window.Tracker.logEvent({
                event_name: "open",
                event_category: "dialog",
                event_label: id,
            });
        });
        this.registerBusEvent('closeAppDialogs', () => {
            this.dialog = "";
        });
    },
    methods: {
        close() {
            this.dialog = "";
        }
    }
}
</script>
